/* eslint-env browser */
import eventLib from 'gator';

const listenDirectlyFor = (domEvent, handler) => element =>
  eventLib(element)
    .off(domEvent, handler)
    .on(domEvent, handler);

const actionElements = selector => (elements, element) =>
  elements.concat(
    element.matches(selector) ? element : [],
    Array.from(element.querySelectorAll(selector))
  );

const selectorFor = action => `[data-track-action~=${action}]`;

const removeDirectlyFor = (domEvent, handler) => element =>
  eventLib(element).off(domEvent, handler);

const delegateListeningTo = element => ({ action, domEvent, handler }) =>
  eventLib(element)
    .off(domEvent, selectorFor(action), handler)
    .on(domEvent, selectorFor(action), handler);

const handleAddedNodes = (element, action, elements) => {
  if (!action.delegate) {
    elements
      .filter(e => e.nodeType === global.Node.ELEMENT_NODE)
      .reduce(actionElements(selectorFor(action.action)), [])
      .forEach(listenDirectlyFor(action.domEvent, action.handler));
  }
};

const handleRemovedNodes = (element, action, elements) => {
  const els = elements
    .filter(e => e.nodeType === global.Node.ELEMENT_NODE)
    .reduce(actionElements(selectorFor(action.action)), []);

  if (action.delegate && els.length > 0) {
    delegateListeningTo(element)(action);
  } else if (!action.delegate) {
    els.forEach(removeDirectlyFor(action.domEvent, action.handler));
  }
};

export const delegated = (actions, scope) =>
  actions.forEach(delegateListeningTo(scope));

const bindCurrentElementsWithin = element => ({ action, domEvent, handler }) =>
  element
    .querySelectorAll(selectorFor(action))
    .forEach(listenDirectlyFor(domEvent, handler));

export const directCurrent = (actions, scope) =>
  actions.forEach(bindCurrentElementsWithin(scope));

const listenFutureElementWithin = element => action =>
  new global.MutationObserver(mutations => {
    mutations.forEach(mutation => {
      handleRemovedNodes(element, action, Array.from(mutation.removedNodes));
      handleAddedNodes(element, action, Array.from(mutation.addedNodes));
    });
  }).observe(element, { childList: true, subtree: true });

export const listenFuture = (actions, scope) =>
  actions.forEach(listenFutureElementWithin(scope));

// ATs use a version of FF that SSTK does not support and that does not
// support NodeList.forEach; querySelectorAll returns NodeList so we must
// use a polyfill from
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
/* eslint-disable no-param-reassign, func-names */

if (
  typeof window !== 'undefined' &&
  window.NodeList &&
  !NodeList.prototype.forEach
) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || (typeof window !== 'undefined' && window);
    for (let i = 0; i < this.length; i += 1) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
